import { ConfigProvider } from "antd";
import { CustomThemeProvider } from "customHooks/ThemeContext";
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-loading-skeleton/dist/skeleton.css'
import React, { lazy } from "react";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import MainScreenLoader from "loaders/MainScreenLoader";

import { AppProvider } from "zustand/Store";

const AppRoutes = lazy(() => import('routes/Routes'));


function App() {
	return (
		<AppProvider>
			<React.Suspense fallback={<MainScreenLoader />}>
				<CustomThemeProvider>
					<ThemeProvider
						theme={{ primary: "#D85F5F" }}>
						<ConfigProvider
							theme={{
								token: { colorPrimary: "#D85F5F", colorPrimaryActive: "#D85F5F" },
								components: {
									Timeline: { tailColor: '#D8D8EA' }
								}
							}}
						>
							<AppRoutes />
							<ToastContainer />
						</ConfigProvider>
					</ThemeProvider>
				</CustomThemeProvider>
			</React.Suspense>
		</AppProvider>
	);
}

export default App;